/* eslint-disable no-undef */
import React, { useState, useContext } from 'react'
import useRWD from '../../hook/useRWD'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Form, Input, message } from 'antd'
import {
    MailOutlined,
    ApartmentOutlined,
} from '@ant-design/icons'
import axios from 'axios'
import dayjs from 'dayjs'
import bg from '../../images/loginbg.jpg'
import bg_m from '../../images/loginbg_m.jpg'
import logo_w from '../../images/logo_w.svg'
import { IsEmail } from '../../functionTool/valid'
import { SettingContext } from '../../store/SettingProvider'

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false)
    const [emailStatus, setEmailStatus] = useState('');
    const device = useRWD()
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { customerSettings } = useContext(SettingContext)

    //客戶設定
    const customerProfileInfo = customerSettings?.[0]?.profileInfo

    //客戶名稱
    const ownerName = customerProfileInfo?.ownerName || '微電能源管理系統'

    //客戶logo url
    const logoUrl = customerProfileInfo?.darkLogoURL || logo_w

    //客戶PC登入背景
    const loginPCBackgroundImage = customerProfileInfo?.loginPCBackgroundImage || bg

    //客戶Mobile登入背景
    const loginMobileBackgroundImage = customerProfileInfo?.loginMobileBackgroundImage || bg_m

    //客戶官網
    const customerOfficialWebsite = customerProfileInfo?.officialWebsite

    //客戶聯絡我們
    const customerContactEmail = customerProfileInfo?.contactEmail || 'austin.hung@rfdme.com'

    const handleForgotPassword = async (values) => {
        const email = values.email;
        if (email) {
          if (!IsEmail(email)) {
            setEmailStatus('error');
            // 顯示錯誤訊息
            form.setFields([
              {
                name: 'email',
                errors: ['請輸入有效的電子郵件格式'],
              },
            ]);
          } else {
            setEmailStatus('validating');
            setLoading(true);
    
            await axios
              .post(`${process.env.REACT_APP_APIGATEWAY_URL}/auth/user/forgetpwd`, {
                systemID: process.env.systemID,
                email: email,
              })
              .then((res) => {
                if (res && res.data && res.data.status === true) {
                  message.success({
                    content: (
                      <div>
                        <strong>請至您的信箱確認忘記密碼信件</strong>
                        <div>系統將於 3 秒後返回登出頁面，請完成信件指示後再次登入</div>
                      </div>
                    ),
                  });
    
                  setEmailStatus('success');
    
                  // 跳轉回登入頁面
                  setTimeout(() => {
                    navigate('/login');
                  }, 3000);
                } else {
                  const msg = res.data.msg;
                  console.warn(`forgetPwd fail: ${msg}`);
                  message.error(msg);
                }
              })
              .catch((err) => {
                console.error(`forgetPwd fail: ${err}`);
              })
              .finally(() => {
                setLoading(false);
              });
          }
        }
    };

    const handleEmailChange = () => {
        if (emailStatus !== '') {
          setEmailStatus('');
        }
    };

    return (
        <div
            className="app-login"
            style={
                device !== 'hisesPC' && device !== 'PC'
                    ? { backgroundImage: `url(${loginMobileBackgroundImage})` }
                    : { backgroundImage: `url(${loginPCBackgroundImage})` }
            }
        >
            <div className="app-login-header">
                <div className="container">
                    <div className="app-login-header-menu">
                        <div className="logo">
                            <img src={logoUrl} alt={ownerName} />
                        </div>
                        <div className="menu">
                            <ol>
                                {customerOfficialWebsite && <li>
                                    <Button
                                        type="link"
                                        target="_blank"
                                        href={customerOfficialWebsite}
                                        icon={<ApartmentOutlined />}
                                    >
                                        公司官網
                                    </Button>
                                </li>}
                                {/* <li>
                                    <Button type="link" icon={<UserOutlined />}>
                                        個人訊息
                                    </Button>
                                </li>
                                <li>
                                    <Button type="link" icon={<FormOutlined />}>
                                        註冊新帳號
                                    </Button>
                                </li> */}
                            </ol>
                            <div className="btn">
                                <Button href={`mailto:${customerContactEmail}`} ghost>聯絡我們</Button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className="app-login-content">
                <div className="container">
                    <div className="app-login-form">
                        <h1>忘記您的密碼?</h1>
                        <div className='app-login-form-subtitle'>請輸入註冊的電子郵件以接收密碼重設指示</div>
                        <Form
                            form={form}
                            name="forgotPassword"
                            layout="vertical"
                            onFinish={handleForgotPassword}
                            size="large"
                            autoComplete="off"
                        >
                            <Form.Item
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: '請輸入正確的電子郵件格式',
                                    },
                                ]}
                                validateStatus={emailStatus}
                            >
                                <Input
                                    prefix={
                                        <MailOutlined className="site-form-item-icon" />
                                    }
                                    autoFocus
                                    key="email"
                                    placeholder="example@example.com"
                                    onChange={handleEmailChange}
                                />
                            </Form.Item>

                            <div className='app-login-form-remember'>
                                <span style={{marginRight: 8}}>記得密碼?</span>
                                <Link to="/login">
                                    登入
                                </Link>
                            </div>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    block
                                >
                                    寄送
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
            <div className="app-login-footer">
                <div className="container">
                    <p>
                        ©{dayjs().year()} Micro Electricity Co., Ltd. All
                        rights reserved.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword
